import moment from "moment";
import { hasProductManageAccess, isAdmin, ORGANIZATION_ROLES } from "../../../../utils/constants";

const getProductFieldDropdownOptions = (value, label) => {
    return {
        value: value,
        label: label
    }
}

const productAvailabilityOptions = [getProductFieldDropdownOptions('in stock', "In stock"), getProductFieldDropdownOptions('out of stock', "Out of stock")]
const productConditionOptions = [getProductFieldDropdownOptions('new', "New"), getProductFieldDropdownOptions('refurbished', "Refurbished"), getProductFieldDropdownOptions('used', "Used")]
export const genderOptions = [getProductFieldDropdownOptions('female', "Female"), getProductFieldDropdownOptions('male', "Male"), getProductFieldDropdownOptions('unisex', "Unisex")]
export const ageGroupOptions = [
    getProductFieldDropdownOptions('adult', "Adult"),
    getProductFieldDropdownOptions('all ages', "All Ages"),
    getProductFieldDropdownOptions('teen', "Teen"),
    getProductFieldDropdownOptions('kids', "Kids"),
    getProductFieldDropdownOptions('toddler', "Toddler"),
    getProductFieldDropdownOptions('infant', "Infant"),
    getProductFieldDropdownOptions('newborn', "Newborn")
]

export const productFields = [
    {
        name: "WhatsApp Catalog", 
        key: "wa_catalog_id", 
        getCallResponseKey: "wa_catalog_id",
        flag_required: false, 
        flag_additional_info: false, 
        flag_dropdown: true,
        field_placeholder: "Select whatsapp catalog", 
        xs_value: 12,
    },
    {
        name: "Product Name", 
        key: "product_name",  
        getCallResponseKey: "ecom_product_name",
        flag_required: true, 
        flag_additional_info: false, 
        field_placeholder: "Enter product name", 
        xs_value: 6,
    },
    {
        name: "Product Category", 
        key: "product_type",
        getCallResponseKey: "type",
        flag_required: false, 
        flag_additional_info: false,
        field_placeholder: "e.g Electronics, Beauty, Apparel... ", 
        xs_value: 6,
    }, 
    {
        name: "Product Source Unique ID", 
        key: "product_source_unique_id",
        getCallResponseKey: "ecom_product_source_unique_id",
        flag_required: false, 
        flag_additional_info: false, 
        field_placeholder: "Enter unique product ID", 
        xs_value: 6,
    }, 
    {
        name: "Product Sub Header", 
        key: "product_sub_header", 
        getCallResponseKey: "ecom_product_sub_header",
        flag_required: false, 
        flag_additional_info: false, 
        field_placeholder: "Enter sub header", 
        xs_value: 6,
    },
    {
        name: "Product Price", 
        key: "product_price",  
        getCallResponseKey: "ecom_product_price",
        flag_required: true, 
        flag_additional_info: false, 
        field_placeholder: "Enter product price", 
        xs_value: 6,
    }, 
    {
        name: "Product Price Currency", 
        key: "product_price_currency", 
        getCallResponseKey: "ecom_product_price_currency",
        flag_required: true, 
        flag_additional_info: false, 
        flag_dropdown: true,
        field_placeholder: "Select currency", 
        xs_value: 6,
    }, 
    {
        name: "Product Image", 
        key: "product_image", 
        getCallResponseKey: "ecom_product_image",
        flag_required: false, 
        flag_additional_info: false, 
        flag_file_upload: true,
        field_placeholder: "Enter product image URL", 
        xs_value: 12,
    }, 
    {
        name: "Product Link", 
        key: "ecom_product_link", 
        getCallResponseKey: "ecom_product_link",
        flag_required: true, 
        flag_additional_info: false, 
        flag_show_when_whatsapp_catalog: true,
        flag_file_upload: true,
        field_placeholder: "Enter product link", 
        xs_value: 12,
    }, 
    {
        name: "Product Availability", 
        key: "ecom_product_availability", 
        getCallResponseKey: "ecom_product_availability",
        flag_required: true, 
        flag_additional_info: false, 
        flag_dropdown: true,
        flag_show_when_whatsapp_catalog: true,
        options: productAvailabilityOptions,
        field_placeholder: "Select product availability", 
        xs_value: 6,
    }, 
    {
        name: "Product Condition", 
        key: "ecom_product_condition", 
        getCallResponseKey: "ecom_product_condition",
        flag_required: true, 
        flag_additional_info: false, 
        flag_dropdown: true,
        flag_show_when_whatsapp_catalog: true,
        options: productConditionOptions,
        field_placeholder: "Select product condition", 
        xs_value: 6,
    }, 
    {
        name: "Product Brand", 
        key: "ecom_product_brand", 
        getCallResponseKey: "ecom_product_brand",
        flag_required: true, 
        flag_additional_info: false, 
        flag_show_when_whatsapp_catalog: true,
        field_placeholder: "Enter product brand name", 
        xs_value: 6,
    },
    {
        name: "Product Item Group ID", 
        key: "ecom_product_item_group_id", 
        getCallResponseKey: "ecom_product_item_group_id",
        flag_required: false, 
        flag_additional_info: false, 
        flag_show_when_whatsapp_catalog: true,
        field_placeholder: "Enter product item group id", 
        xs_value: 6,
    },
    {
        name: "Product Description", 
        key: "product_description", 
        getCallResponseKey: "ecom_product_description",
        flag_required: false,  
        flag_additional_info: false, 
        field_placeholder: "Enter detailed product description", 
        xs_value: 12,
    }, 
    {
        name: "Additional Information", 
        key: "additional_information_json", 
        getCallResponseKey: "ecom_additional_fields_json",
        flag_required: false, 
        flag_additional_info: true,
        field_placeholder: "Enter any additional information (specs, instructions, etc.)", 
        xs_value: 12,
    },
    {
        name: "QR Code", 
        key: "flag_ecom_product_qr_code", 
        getCallResponseKey: "flag_ecom_product_qr_code",
        flag_required: false, 
        flag_additional_info: false,
        field_placeholder: "", 
        xs_value: 12,
    }
] 

export const getProductTableFields = (hasWhatsAppCatalogsData) => {
    const whatsAppCatalogTableFieldKeys = new Set([
        "ecom_product_link",
        "ecom_product_availability",
        "ecom_product_condition",
        "ecom_product_brand",
        "ecom_product_item_group_id",
    ]);

    const filteredFields = productFields.filter((field) => {
        if (whatsAppCatalogTableFieldKeys.has(field?.key)) {
            return hasWhatsAppCatalogsData;
        }
        return true;
    });

    if (!hasWhatsAppCatalogsData) {
        return filteredFields;
    }

    const tableOnlyOptionalDataField = {
        name: "Catalog Optional Data",
        key: "catalog_product_optional_data",
        getCallResponseKey: "catalog_product_optional_data",
        flag_required: false,
        flag_file_upload: false,
        flag_additional_info: false,
        field_placeholder: "",
        xs_value: 6,
    };

    const productItemGroupFieldIndex = filteredFields.findIndex((field) => field?.key === "ecom_product_item_group_id");

    if (productItemGroupFieldIndex === -1) {
        return [...filteredFields, tableOnlyOptionalDataField];
    }

    return [
        ...filteredFields.slice(0, productItemGroupFieldIndex + 1),
        tableOnlyOptionalDataField,
        ...filteredFields.slice(productItemGroupFieldIndex + 1),
    ];
};

export const getGenericDataTypeName = (dataTypeId, genericDataTypeList) => {
    return genericDataTypeList?.find((dataType) => dataType?.data_type_id === dataTypeId)?.data_type_name ?? "";
};

export const OPTIONAL_DATE_RANGE_STORAGE_FORMAT = "YYYY-MM-DD";
export const OPTIONAL_DATE_RANGE_DISPLAY_FORMAT = "DD-MMM-YYYY";

export const getOptionalFieldInputType = (dataTypeName) => {
    const normalizedDataTypeName = String(dataTypeName ?? "").trim().toLowerCase();
    return normalizedDataTypeName;
};

const OPTIONAL_DATE_RANGE_BE_REGEX = /^(\d{4}-\d{2}-\d{2})T\d{2}:\d{2}([+-]\d{2}:\d{2})$/;

export const getUtcOffsetMinutesFromUserTimezone = (timeZone) => {
    const offsetMatch = String(timeZone ?? "").match(/^UTC([+-]\d{1,2}):?(\d{2})?$/);
    if (offsetMatch) {
        const offsetHours = parseInt(offsetMatch[1], 10);
        const offsetMinutes = parseInt(offsetMatch[2] || "0", 10);
        return offsetHours * 60 + (offsetHours < 0 ? -offsetMinutes : offsetMinutes);
    }
    return moment().utcOffset();
};

const parseOptionalDateRangePart = (datePart) => {
    if (!String(datePart ?? "").trim()) {
        return null;
    }

    const beFormatMatch = String(datePart).trim().match(OPTIONAL_DATE_RANGE_BE_REGEX);
    if (beFormatMatch) {
        const parsedDate = moment(beFormatMatch[1], OPTIONAL_DATE_RANGE_STORAGE_FORMAT, true);
        return parsedDate?.isValid() ? parsedDate : null;
    }

    const parsedDate = moment(datePart, [OPTIONAL_DATE_RANGE_STORAGE_FORMAT, OPTIONAL_DATE_RANGE_DISPLAY_FORMAT, moment.ISO_8601], true);
    return parsedDate?.isValid() ? parsedDate : null;
};

export const parseOptionalDateRangeValue = (value) => {
    if (!String(value ?? "").trim()) {
        return { startDate: null, endDate: null };
    }

    const [startValue = "", endValue = ""] = String(value).split("/");
    const startDate = parseOptionalDateRangePart(startValue);
    const endDate = parseOptionalDateRangePart(endValue);

    return {
        startDate: startDate ? startDate.clone().startOf("day") : null,
        endDate: endDate ? endDate.clone().startOf("day") : null,
    };
};

export const formatOptionalDateRangeValue = (startDate, endDate, timeZone) => {
    if (!startDate?.isValid?.()) {
        return "";
    }

    const utcOffsetMinutes = getUtcOffsetMinutesFromUserTimezone(timeZone);
    const start = startDate.clone().utcOffset(utcOffsetMinutes, true).startOf("day");
    const offsetString = start.format("Z");

    if (!endDate?.isValid?.()) {
        return `${start.format("YYYY-MM-DD")}T00:00${offsetString}/`;
    }

    const end = endDate.clone().utcOffset(utcOffsetMinutes, true).startOf("day");
    return `${start.format("YYYY-MM-DD")}T00:00${offsetString}/${end.format("YYYY-MM-DD")}T23:59${offsetString}`;
};

export const getWhatsAppCatalogDisplayLabel = (waCatalogId, whatsAppCatalogsData) => {
    if (!waCatalogId) {
        return "";
    }
    const catalog = (whatsAppCatalogsData ?? []).find((item) => item.wa_catalog_id === waCatalogId);
    if (catalog) {
        return `${catalog.wa_catalog_name} (${catalog.waba_name})`;
    }
    return String(waCatalogId);
};

export const requiredWhenWhatsAppCatalogFieldKeys = [
    "ecom_product_availability",
    "ecom_product_condition",
    "ecom_product_link",
    "ecom_product_brand",
    "product_description",
    "product_price_currency",
    "product_image",
    "product_source_unique_id"
]; 

export const whatsappCatalogMaxLengthValidation = {
    product_source_unique_id: 200,
    product_name: 200,
    product_description: 9999,
    ecom_product_brand: 100,
    ecom_product_item_group_id: 100,
    color: 200,
    size: 200,
    material: 200,
    pattern: 100,
};

export const getSalePriceValidationMessage = (salePriceValue, productPrice) => {
    const salePriceText = String(salePriceValue ?? "").trim();
    if (!salePriceText.length) {
        return "";
    }

    const salePrice = Number(salePriceText);
    if (Number.isNaN(salePrice)) {
        return "";
    }

    const productPriceNumber = Number(productPrice);
    if (Number.isNaN(productPriceNumber) || salePrice > productPriceNumber) {
        return "Sale price must be less than or equal to product price";
    }

    return "";
};

const GTIN_VALID_LENGTHS = [8, 12, 13, 14];

export const isValidGtin = (value) => {
    const gtinText = String(value ?? "").trim();
    if (!gtinText.length) {
        return true;
    }

    // Allow digits with optional hyphen/space separators (e.g. 400-6381-33393-1).
    if (!/^[\d\s-]+$/.test(gtinText)) {
        return false;
    }

    const digits = gtinText.replace(/\D/g, "");
    if (!digits.length || !GTIN_VALID_LENGTHS.includes(digits.length)) {
        return false;
    }

    let sum = 0;
    for (let index = 0; index < digits.length - 1; index++) {
        const digit = parseInt(digits[index], 10);
        sum += digit * (index % 2 === 0 ? 1 : 3);
    }

    const expectedCheckDigit = (10 - (sum % 10)) % 10;
    return expectedCheckDigit === parseInt(digits[digits.length - 1], 10);
};

export const getGtinValidationMessage = (gtinValue) => {
    const gtinText = String(gtinValue ?? "").trim();
    if (!gtinText.length) {
        return "";
    }

    const gtinValues = gtinText?.split(",")?.map((value) => value.trim())?.filter((value) => value.length > 0);

    const hasInvalidGtin = gtinValues?.some((value) => !isValidGtin(value));
    if (hasInvalidGtin) {
        return "Please enter a valid GTIN (8, 12, 13, or 14 digits)";
    }

    return "";
};

export const getDefaultPayload = (selectedProduct) => {
    return {
        product_id: selectedProduct ? selectedProduct?.ecom_product_id : null, 
        product_source_unique_id: selectedProduct ? selectedProduct?.ecom_product_source_unique_id ?? "" : "", 
        product_name: selectedProduct ? selectedProduct?.ecom_product_name : "", 
        product_sub_header: selectedProduct ? selectedProduct?.ecom_product_sub_header : "", 
        product_description: selectedProduct ? selectedProduct?.ecom_product_description : "", 
        product_price: selectedProduct ? selectedProduct?.ecom_product_price : null, 
        product_image: selectedProduct ? selectedProduct?.ecom_product_image : "", 
        product_type: selectedProduct ? selectedProduct?.type : "", 
        additional_information_json: selectedProduct ? selectedProduct?.ecom_additional_fields_json : "", 
        product_price_currency: selectedProduct ? selectedProduct?.ecom_product_price_currency : "INR",
        wa_catalog_id: selectedProduct ? selectedProduct?.wa_catalog_id ?? "" : "",
        waba_id: selectedProduct ? selectedProduct?.waba_id ?? "" : "",
        ecom_product_availability: selectedProduct ? selectedProduct?.ecom_product_availability ?? "" : "",
        ecom_product_condition: selectedProduct ? selectedProduct?.ecom_product_condition ?? "" : "",
        ecom_product_link: selectedProduct ? selectedProduct?.ecom_product_link ?? "" : "",
        ecom_product_brand: selectedProduct ? selectedProduct?.ecom_product_brand ?? "" : "",
        ecom_product_item_group_id: selectedProduct ? selectedProduct?.ecom_product_item_group_id ?? "" : "",
        catalog_product_optional_data: selectedProduct?.catalog_product_optional_data ?? [],
        flag_ecom_product_qr_code: selectedProduct ? selectedProduct?.flag_ecom_product_qr_code : false,
        ecom_product_qr_code_count: selectedProduct ? selectedProduct?.ecom_product_qr_code_count : 0,
        ecom_product_qr_code_data: selectedProduct ? selectedProduct?.ecom_product_qr_code_data : []
    }
}

export const emptyProductQrCodeObj = {
    flag_expiry: false,
    flag_multiple_scan: false,
    ecom_product_qr_code_header: '',
    ecom_product_qr_code_description: ''
}

export const sortCatalogProductOptionalField = (catalogProductOptionalFieldData) => {
    return [...(catalogProductOptionalFieldData ?? [])].sort((firstField, secondField) => (firstField?.field_sequence ?? 0) - (secondField?.field_sequence ?? 0));
}